import React, { FC } from 'react';
import useSubjects from '../hooks/useSubjects';
import Button from '../lib/components/Button';
import Flex from '../lib/components/Flex';
import Label from '../lib/components/Label';
import { MultiSelectOption, SelectOption } from '../typings/select-option.typings';

interface Props {
  values: MultiSelectOption;
  onChange: (a: SelectOption) => () => void;
}

const AreaTags: FC<Props> = ({
  values,
  onChange,
}) => {
  const classifications = useSubjects();

  return (
    <>
      <Label>Grandes áreas</Label>
      <Flex wrap align="center">
        {
          classifications.getList().map((i) => {
            const find = values.find((item) => item.value === i._id);
            return (
              <Button
                key={i._id}
                variant={find ? 'contained' : 'default'}
                onClick={onChange({ value: i._id, label: i.name })}
                className="m-0"
                elevated
              >
                {i.name}
              </Button>
            );
          })
        }
      </Flex>
    </>
  );
};

export default AreaTags;
